// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about-section {
  text-align: center;
}

.about-section p {
  font-size: 2rem;
  margin-bottom: 20px;
  color: pink;
  -webkit-text-stroke: 1px black; /* outline thickness + color */
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/Sections/About/About.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,8BAA8B,EAAE,8BAA8B;EAC9D,gBAAgB;AAClB","sourcesContent":[".about-section {\n  text-align: center;\n}\n\n.about-section p {\n  font-size: 2rem;\n  margin-bottom: 20px;\n  color: pink;\n  -webkit-text-stroke: 1px black; /* outline thickness + color */\n  font-weight: 400;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
